import { createTheme, TextField, ThemeProvider, styled } from "@mui/material";
import React from "react";
import { useState } from "react";
import { toTitleCase } from "../../helpers/string";
import { SurveyMainType } from "../../types/SurveyMainType";
import { SurveyQuestionType } from "../../types/SurveyQuestionType";
import useWindowDimensions from "../../hooks/useWindowDimensions";

interface ISurveyMultiSelectProps {
  question: SurveyQuestionType;
  pppData?: React.Dispatch<React.SetStateAction<SurveyMainType | undefined>>;
  errorIds?: number[];
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root .MuiAutocomplete-input:first-child": {
    height: 30,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: 13,
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    transform: "translate(14px, -6px) scale(0.75) !important",
  },
  "& .MuiInputLabel-root": {
    transform: "translate(14px, 20px) scale(1)",
  },
}));

const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          display: "none",
        },
      },
    },
  },
});

const SurveyMultiSelect = ({
  question,
  pppData,
  errorIds,
}: ISurveyMultiSelectProps) => {
  const [value, setValue] = useState<string[]>([]);
  const [otherValue, setOtherValue] = useState<string>("");

  if (pppData == null) return null;

  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <div className="hrMargin" />

      <p>{question.text}</p>
      <div id="sourceOfAssetValues">
        {question.answers &&
          question.answers.map((c) => {
            return (
              <div
                key={c.id}
                onClick={() => {
                  pppData((prev) => {
                    const q = prev?.questions.find((f) => f.id === question.id);
                    if (q == null || q.answers == null) return prev;

                    q.answerValueText = undefined;
                    q.isTouched = true;
                    const a = q.answers.find((f) => f.id === c.id);
                    if (a == null) return prev;
                    if (!a.isSelected && a.checkBoxReset) {
                      q.answers.forEach((ans) => (ans.isSelected = false));
                    } else {
                      const reset = q.answers.find(
                        (f) => f.checkBoxReset === true
                      );
                      if (reset) {
                        reset.isSelected = false;
                      }
                    }

                    a.isSelected = !c.isSelected;
                    a.additionalText = undefined;
                    if (prev) return { ...prev };
                  });
                  setValue((prev) => {
                    if (prev.indexOf(c.answerText) === -1) {
                      prev.push(c.answerText);
                      return [...prev];
                    } else {
                      return [...prev.filter((f) => f !== c.answerText)];
                    }
                  });
                }}
                className="custom-control custom-checkbox"
              >
                <input
                  value={c.answerText}
                  type="checkbox"
                  className="custom-control-input"
                  checked={c.isSelected}
                />
                <label className="custom-control-label">{c.answerText}</label>

                {c.isSelected && c.showTextBox ? (
                  <div className="form-group mt-3 mb-1">
                    <StyledTextField
                      variant="outlined"
                      label={c.additionalTextBoxLabel ?? ""}
                      value={question.answerValueText}
                      error={errorIds && errorIds.indexOf(question.id) !== -1}
                      onClick={(
                        event: React.MouseEvent<HTMLDivElement, MouseEvent>
                      ) => {
                        event.stopPropagation();
                      }}
                      onChange={(event: any) => {
                        const val = toTitleCase(event.target.value);
                        pppData((prev) => {
                          const q = prev?.questions.find(
                            (f) => f.id === question.id
                          );
                          if (q == null || q.answers == null) return prev;

                          q.isTouched = true;
                          const a = q.answers.find((f) => f.id === c.id);
                          if (a == null) return prev;
                          a.additionalText = val;

                          if (prev) return { ...prev };
                        });
                        setOtherValue(val);
                      }}
                      inputProps={{
                        maxLength: 200,
                      }}
                      InputLabelProps={{
                        style: {
                          fontSize: 13,
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                        },
                      }}
                    />
                    {errorIds &&
                      errorIds.indexOf(question.id) !== -1 &&
                      question.answers?.some(
                        (item) => item.isSelected && item.showTextBox
                      ) && (
                        <span className="validationError" role="alert">
                          <i className="fa fa-exclamation-circle" />
                          To pole jest wymagane
                        </span>
                      )}
                  </div>
                ) : null}
              </div>
            );
          })}
        {errorIds &&
          errorIds.indexOf(question.id) !== -1 &&
          question.answers?.filter(
            (item) => item.isSelected && item.showTextBox
          ).length === 0 && (
            <span className="validationError" role="alert">
              <i className="fa fa-exclamation-circle" />
              To pole jest wymagane
            </span>
          )}
      </div>
    </ThemeProvider>
  );
};

export { SurveyMultiSelect };
